import * as React from 'react';

const SvgStarRed = (props) => (
  <svg
    width={33}
    height={31}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.577 1.22c.341-.821 1.505-.821 1.846 0l3.604 8.663a1 1 0 0 0 .843.613l9.352.75c.887.07 1.247 1.177.571 1.756l-7.126 6.104a1 1 0 0 0-.322.991l2.177 9.127c.207.865-.735 1.549-1.494 1.085l-8.007-4.89a1 1 0 0 0-1.042 0l-8.007 4.89c-.76.464-1.7-.22-1.494-1.085l2.177-9.127a1 1 0 0 0-.322-.991l-7.126-6.104c-.676-.579-.316-1.685.57-1.756l9.353-.75a1 1 0 0 0 .843-.613l3.604-8.663Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgStarRed;
